module.exports = __webpack_public_path__ + "static/media/pic4.325164f1.jpg";